import { Drawer, makeStyles } from '@material-ui/core'
import deburr from 'lodash.deburr'
import PropTypes from 'prop-types'
import React, { useLayoutEffect, useState } from 'react'

import searchIcon from '../../assets/images/search.svg'

function QuizRanking(props) {
  const [data, setData] = useState([])
  const [query, setQuery] = useState('')
  const classes = useStyles()

  useLayoutEffect(() => {
    if (!props.data) return

    setData(sortData(props.data, props.totalQuestions))
  }, [props.data])

  useLayoutEffect(() => {
    if (props.open) setQuery('')
  }, [props.open])

  const handleQueryChange = e => setQuery(e.target.value)

  const queryRegexp = new RegExp(deburr(query), 'i')
  const finalData = data.filter(item => queryRegexp.test(deburr(item.name + item.email)))

  return (
    <Drawer
      anchor="right"
      open={props.open}
      onClose={props.onClose}
      classes={{
        paper: classes.paper
      }}
    >
      <h1 className={classes.title}>Ranking Completo</h1>
      <div className={classes.row}>
        <input
          className={classes.search}
          value={query}
          onChange={handleQueryChange}
          placeholder="Buscar..."
        />
      </div>
      <table className={classes.table}>
        <colgroup>
          <col className={classes.fitContent} />
          <col />
          <col className={classes.fitContent} />
          <col className={classes.fitContent} />
        </colgroup>
        <thead>
          <tr>
            <td>#</td>
            <td>Usuário</td>
            <td>Acertos</td>
            <td>Tempo</td>
          </tr>
        </thead>
        <tbody>
          {finalData.map(item => (
            <tr key={item.id}>
              <td>{item.position}</td>
              <td>{item.name}</td>
              <td>{item.correctReplies}</td>
              <td>{item.time}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Drawer>
  )
}

QuizRanking.propTypes = {
  data: PropTypes.arrayOf({
    dateTimeEnd: PropTypes.string.isRequired,
    dateTimeStart: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    note: PropTypes.number.isRequired
  }),
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  totalQuestions: PropTypes.number.isRequired
}

const sortData = (data, totalQuestions) => {
  const getTime = data => new Date(data.dateTimeEnd) - new Date(data.dateTimeStart)

  const sorted = Object.entries(
    data.reduce(
      (accumulative, current) => ({
        ...accumulative,
        [current.note]: [...(accumulative[current.note] || []), current].sort(
          (one, another) => getTime(one) - getTime(another)
        )
      }),
      {}
    )
  )
    .sort(([one], [another]) => -one + another)
    .map(([, item]) => item)
    .flat()

  const mapped = sorted.map((item, index) => ({
    ...item,
    time: (item => {
      const time = getTime(item)
      if (time >= 60 * 60 * 1000) return '1h+'

      const minutes = ~~(time / 60000)
      const seconds = ~~((time % 60000) / 1000)
      return `${String(minutes)}'${String(seconds)}''`
    })(item),
    correctReplies: `${String(~~((item.note / 10) * totalQuestions))}/${String(totalQuestions)}`,
    position: index + 1
  }))

  return mapped
}
QuizRanking.sortData = sortData

const useStyles = makeStyles({
  paper: {
    padding: '45px'
  },
  title: {
    marginBottom: '35px',
    fontFamily: 'Matrice',
    fontSize: '24px',
    color: '#30287b'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: '35px'
  },
  search: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    width: 190,
    height: 40,
    padding: '10px 15px',
    boxSizing: 'border-box',
    fontSize: '12px',
    color: '#30287b',
    background: `url(${searchIcon}) top right / auto 100% content-box no-repeat`,
    border: '2px solid #30287b'
  },
  table: {
    width: '100%',
    margin: '-10px 0',
    '& td': {
      padding: '10px 15px',
      fontWeight: '500',
      color: '#30287b'
    },
    '& thead td': {
      fontSize: '14px',
      fontWeight: 700
    },
    '& td:first-child': {
      fontSize: '18px !important',
      fontWeight: 700
    },
    '& td:nth-child(2)': {
      fontWeight: 700
    },
    '& td:not(:nth-child(2))': {
      textAlign: 'center'
    },
    '& tbody tr:hover td': {
      backgroundColor: '#ece5fe'
    },
    '& tbody td': {
      transition: 'background-color .1s ease'
    },
    '& tbody td:first-child': {
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4
    },
    '& tbody td:last-child': {
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4
    }
  },
  fitContent: {
    width: 'fit-content'
  }
})

export default QuizRanking
